import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export interface IRoomBed {
  type: string;
  quantity: number;
}

export const BED_TYPES = [
  'king_bed',
  'california_king_bed',
  'queen_bed',
  'double_bed',
  'small_double_bed',
  'single_bed',
  'bunk_bed',
  'sofa_bed',
  'water_bed',
  'trundle_bed',
  'air_mattress_bed',
  'couch_bed',
  'crib_bed',
  'floor_mattress_bed',
  'futon_bed',
  'hammock_bed',
  'toddler_bed',
];

export const ROOM_TYPES = [
  'art_studio',
  'backyard',
  'balcony',
  'bedroom',
  'bowling_alley',
  'casino',
  'childrens_playroom',
  'courtyard',
  'darkroom',
  'dining_room',
  'event_room',
  'exterior',
  'front_yard',
  'full_bathroom',
  'game_room',
  'garage',
  'gym',
  'half_bathroom',
  'hot_tub',
  'kitchen',
  'kitchenette',
  'laundry_room',
  'library',
  'living_room',
  'movie_theater',
  'music_studio',
  'office',
  'patio',
  'photography_studio',
  'pool',
  'porch',
  'rooftop',
  'studio',
  'sunroom',
  'terrace',
  'theme_room',
  'wine_cellar',
  'woodshop',
  'workshop',
  'workspace',
];

export const BATHROOM_TYPES = ['full_bathroom', 'half_bathroom'];

export default class RoomModel extends Model {
  @attr('string') roomType!: string;
  @attr('boolean') isPrivate!: boolean;
  @attr('array') beds!: IRoomBed[];

  @belongsTo('property', { async: false, inverse: null })
  property!: ModelRegistry['property'];

  get isBathroom(): boolean {
    return BATHROOM_TYPES.includes(this.roomType);
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    room: RoomModel;
  }
}
